import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';

import {EVENT_REPORT_FORM_COMMENT_MSG, REPORTS_FORMS_COMMENT_MSG} from '@constants/messages';

export const EventReportComment = ({input, defaultValue, rows, hasUpdatePrivileges = true, isReportsForms = true}) => {
    const handlePrefillComment = () => {
        const template = isReportsForms ? EVENT_REPORT_FORM_COMMENT_MSG : REPORTS_FORMS_COMMENT_MSG;
        input.onChange(template);
    };
    const isDisabled = !hasUpdatePrivileges;

    useEffect(() => {
        input.onChange(defaultValue);
    }, [defaultValue]);

    return (
        <div style={{flexDirection: 'column'}}>
            <div className='comment-field' style={{
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'row',
            }}>
                <label htmlFor='comment'>Comment</label>
                <div className='input-container'>
                    <div className='field --comment'>
                        <textarea disabled={isDisabled} name='comment' rows={rows} value={input.value || ''}
                            onChange={input.onChange}></textarea>
                    </div>
                </div>
            </div>
            <div style={{width: '100%'}}>
                <Button type='button' className='comment-btn' onClick={handlePrefillComment} disabled={isDisabled}>
                    Pre-fill with template
                </Button>
            </div>
        </div>
    );
};

EventReportComment.propTypes = {
    defaultValue: PropTypes.string,
    rows: PropTypes.number,
    hasUpdatePrivileges: PropTypes.bool,
    isReportsForms: PropTypes.bool,
    input: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string,
    }).isRequired,
};
